<template>
  <BaseAction>
    <SecondaryButton @click.native="openDialog" color="primary">
      <inline-svg
        :src="require('@/assets/svg/check_white.svg')"
        width="19"
        height="22"
      />
      Confirm Adjustment
    </SecondaryButton>
    <ConfirmAdjustmentDialog
      :label="
        `Please leave a comment indicating the adjustment that was made for ${candidateFullName}`
      "
      v-if="isDialogOpen"
      @close="closeDialog"
    />
  </BaseAction>
</template>

<script>
import ConfirmAdjustmentDialog from "@/views/interviews/dialogs/ConfirmAdjustmentDialog";
import SecondaryButton from "@/components/common/Button/SecondaryButton";
import BaseAction from "@/components/common/BaseAction";
import { getFullName } from "@/utils/users";
import InlineSvg from "vue-inline-svg";

export default {
  name: "ConfirmAdjustmentAction",
  components: {
    BaseAction,
    SecondaryButton,
    ConfirmAdjustmentDialog,
    InlineSvg
  },
  props: {
    candidate: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isDialogOpen: false
    };
  },
  computed: {
    candidateFullName() {
      return getFullName(this.candidate.user);
    }
  },
  methods: {
    openDialog() {
      this.isDialogOpen = true;
    },
    closeDialog() {
      this.isDialogOpen = false;
    }
  }
};
</script>
